export const UserEndpoints = {
  DeleteAccount: '/v3/user/deleteAccount',
  Block: (targetId?: string) => `/v3/user/block/${targetId}`,
  Unblock: (userId?: string) => `/v3/user/block/${userId}`,
  Cups: '/v3/user/cups',
  Medals: '/v3/user/medals',
  Options: '/v3/user/options',
  Password: '/v3/user/password',
  DirectDebit: '/v3/user/directDebit',
  Search: '/v3/user/search',
  InviteCode: '/v3/user/inviteCode',
  Followers: '/v3/user/followers',
  Followings: '/v3/user/followings',
  Follow: '/v3/user/follow',
  SuggestionList: '/v3/user/suggestionList',
  DailyGoal: 'v3/user/goal',
  Leaderboard: '/v3/user/leaderboard/rank',
  LeaderboardTotal: (courseId: string | string[]) =>
    `/v3/user/leaderboard/${courseId}`,
  OtherUserProfile: (id: string) => `/v3/user/profile/${id}`,
  NationalCode: '/v3/user/nationalCode'
} as const
